<h3 mat-dialog-title>{{ data.title }}</h3>
<div mat-dialog-content>{{ data.message }}</div>

<mat-dialog-actions>
    <button mat-button color="primary" cdkFocusInitial (click)="close()">
        <mat-icon>check_circle</mat-icon> {{"ACTIONS.OK" | translate}}
    </button>
</mat-dialog-actions>
